import { types } from '../types';
import translation from '../requests/TranslationRequest';
import { takeLatest, call, put } from 'redux-saga/effects';
import TranslationAction from '../actions/TranslationAction';

export function* getTranslationCacheSaga(action) {
  try {
    const { language } = action;
    const translationReponse = yield call(translation.getTranslationCache, language);
    if (translationReponse) {
      yield put(TranslationAction.translationAuthSuccess(translationReponse));
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* translationSaga() {
  yield takeLatest(types.GET_TRANSLATION_CACHE, getTranslationCacheSaga);
}